import Table from "../../components/table/table";
const MembersDetailsTable = ({ t }) => {
  const members = [
    {
      id: 1,
      name: "هشام المدير أحمد",
      membershipType: "CLB-02345",
      numberOfBookings: "VIP",
      joinDate: "12/06/2023",
    },
    {
      id: 2,
      name: "هشام المدير أحمد",
      membershipType: "CLB-02345",
      numberOfBookings: "VIP",
      joinDate: "12/06/2023",
    },
    {
      id: 3,
      name: "خالد محمود",
      membershipType: "CLB-01012",
      numberOfBookings: "عائلي",
      joinDate: "10/01/2022",
    },
    {
      id: 4,
      name: "سارة عمر",
      membershipType: "CLB-01923",
      numberOfBookings: "شبابي",
      joinDate: "25/05/2024",
    },
    {
      id: 5,
      name: "هشام المدير أحمد",
      membershipType: "CLB-02345",
      numberOfBookings: "VIP",
      joinDate: "12/06/2023",
    },
    {
      id: 6,
      name: "هشام المدير أحمد",
      membershipType: "VIP",
      numberOfBookings: "13",
      joinDate: "12/06/2023",
    },
    {
      id: 7,
      name: "هشام المدير أحمد",
      membershipType: "عائلي",
      numberOfBookings: "13",
      joinDate: "12/06/2023",
    },
    {
      id: 8,
      name: "خالد محمود",
      membershipType: "VIP",
      numberOfBookings: "4",
      joinDate: "10/01/2022",
    },
    {
      id: 9,
      name: "سارة عمر",
      membershipType: "VIP",
      numberOfBookings: "13",
      joinDate: "25/05/2024",
    },
  ];

  const tableHead = [
    {
      header: t("name"),
      accessorKey: "name",
    },

    {
      header: t("membershipType"),
      accessorKey: "membershipType",
    },

    {
      header: t("joinDate"),
      accessorKey: "joinDate",
    },
    {
      header: t("numberOfBookings"),
      accessorKey: "numberOfBookings",
    },
  ];

  return <Table TableData={members} TableHead={tableHead} />;
};

export default MembersDetailsTable;
